import React, { useEffect } from "react";
import { AdvertCard } from "../AdvertCard";
import { useSelector } from "react-redux";

export const AllAdverts = () => {
  const adverts = useSelector((state) => state.misc.adverts) || [];
  usePrintDimensions();

  return adverts.map((advert, index) => (
    <article key={index} className="mt-3">
      <AdvertCard {...advert} />
    </article>
  ));
};

const usePrintDimensions = () => {
  useEffect(() => {
    window.addEventListener("resize", () => {
      let elements = Array.from(document.getElementsByClassName("advertcard"));
      let heights = elements.map((element) => element.offsetHeight);
      console.info("Banner heights: " + heights);
    });
  });
};
